import { create } from 'zustand';

const STORAGE_KEY = 'goodchat_onboarding_complete';

interface OnboardingStore {
  hasCompletedOnboarding: boolean;
  currentStep: number;
  tourActive: boolean;
  startTour: () => void;
  nextStep: () => void;
  prevStep: () => void;
  skipTour: () => void;
  completeTour: () => void;
}

export const useOnboardingStore = create<OnboardingStore>((set) => ({
  hasCompletedOnboarding: localStorage.getItem(STORAGE_KEY) === 'true',
  currentStep: 0,
  tourActive: false,

  startTour: () => set({ tourActive: true, currentStep: 0 }),

  nextStep: () =>
    set((state) => {
      if (state.currentStep >= 4) {
        localStorage.setItem(STORAGE_KEY, 'true');
        return { tourActive: false, hasCompletedOnboarding: true, currentStep: 0 };
      }
      return { currentStep: state.currentStep + 1 };
    }),

  prevStep: () =>
    set((state) => ({
      currentStep: Math.max(0, state.currentStep - 1),
    })),

  skipTour: () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    set({ tourActive: false, hasCompletedOnboarding: true, currentStep: 0 });
  },

  completeTour: () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    set({ tourActive: false, hasCompletedOnboarding: true, currentStep: 0 });
  },
}));
